import { buttonVariants } from "@repo/ui/components/ui/button";
import { Link, type LinkProps } from "@tanstack/react-router";
import { DetailSkeleton } from "@/shared/common/detail-skeleton";

/**
 * Loading. Delegates to the shared detail skeleton — the shell exposes it so
 * routes reach for one name rather than each hand-rolling a skeleton block.
 */
function Pending() {
  return <DetailSkeleton />;
}

interface NotFoundProps {
  /** "Device", "Protocol" — rendered as "<label> not found". */
  label: string;
  backTo: LinkProps["to"];
  backLabel: string;
}

function NotFound({ label, backTo, backLabel }: NotFoundProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <p className="text-muted-foreground">{label} not found</p>
      <Link to={backTo} className={buttonVariants({ variant: "outline" })}>
        {backLabel}
      </Link>
    </div>
  );
}

export { NotFound, Pending };
